import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

const CatalogoClienteListActions = (props) => {
  return (
    <>
      { Guardian.allows('catalogo.cliente.subir.archivo') && (
        <Button as={ Link }
          className="mr-2"
          to="/modulos/catalogo-cliente/archivos/upload"
        >
          Subir archivo
        </Button>
      )}
    </>
  )
}

export default CatalogoClienteListActions;